/**
 * PDP Fabric Modal
 * Works in conjunction with snippets/pdp-fabric-modal.liquid
 * Handles modal open/close, tab switching, FAQ accordion, and scroll lock.
 */

(function($) {
  'use strict';

  $(function() {
    var $modal = $('.pdp-fabrics-modal');
    if (!$modal.length) return;

    // Relocate modal to body for proper z-index stacking
    $modal.appendTo('body');

  /**
   * Open the modal and activate the tab matching the given fabric ID.
   */
  function openModal(fabricId) {
    // Set active tab
    $modal.find('.pdp-fabrics-modal_tab').attr('data-active', 'false');
    $modal.find('.pdp-fabrics-modal_tab[data-fabric-id="' + fabricId + '"]').attr('data-active', 'true');

    // Set active panel
    $modal.find('.pdp-fabrics-modal_panel').attr('data-active', 'false');
    $modal.find('.pdp-fabrics-modal_panel[data-fabric-id="' + fabricId + '"]').attr('data-active', 'true');

    // Update title from the active fabric's name
    var $activePanel = $modal.find('.pdp-fabrics-modal_panel[data-active="true"]');
    var $activeTab = $modal.find('.pdp-fabrics-modal_tab[data-active="true"]');
    $modal.find('.pdp-fabrics-modal_title').html($activeTab.html());

    // Show modal, lock body scroll, reset dialog scroll
    $modal.attr('data-state', 'open');
    document.body.style.overflow = 'hidden';
    $modal.find('.pdp-fabrics-modal_dialog').scrollTop(0);
  }

  /**
   * Close the modal.
   */
  function closeModal() {
    $modal.attr('data-state', 'closed');
    document.body.style.overflow = '';
  }

  // Trigger pill click — open modal with that fabric's tab
  $(document).on('click', '.pdp-fabrics-trigger', function() {
    var fabricId = $(this).attr('data-fabric-id');
    openModal(fabricId);
  });

  // Tab click — switch panels within the modal
  $(document).on('click', '.pdp-fabrics-modal_tab', function() {
    var fabricId = $(this).attr('data-fabric-id');

    // Switch tabs
    $modal.find('.pdp-fabrics-modal_tab').attr('data-active', 'false');
    $(this).attr('data-active', 'true');

    // Switch panels
    $modal.find('.pdp-fabrics-modal_panel').attr('data-active', 'false');
    $modal.find('.pdp-fabrics-modal_panel[data-fabric-id="' + fabricId + '"]').attr('data-active', 'true');

    // Update title
    $modal.find('.pdp-fabrics-modal_title').html($(this).html());

    // Scroll dialog to top
    $modal.find('.pdp-fabrics-modal_dialog').scrollTop(0);
  });

  // Close button
  $(document).on('click', '.pdp-fabrics-modal_close', function() {
    closeModal();
  });

  // Overlay click closes modal
  $(document).on('click', '.pdp-fabrics-modal_overlay', function() {
    closeModal();
  });

  // Escape key closes modal
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $modal.attr('data-state') === 'open') {
      closeModal();
    }
  });

  // FAQ accordion within the modal
  $(document).on('click', '.pdp-fabrics-modal_faq_question', function() {
    var $item = $(this).closest('.pdp-fabrics-modal_faq_item');
    var $faq = $item.closest('.pdp-fabrics-modal_faq');
    var isExpanded = $item.attr('data-state') === 'expanded';

    // Close all siblings
    $faq.find('.pdp-fabrics-modal_faq_item').not($item).each(function() {
      $(this).attr('data-state', 'collapsed');
      $(this).find('.pdp-fabrics-modal_faq_answer').slideUp(300);
    });

    // Toggle clicked item
    if (isExpanded) {
      $item.attr('data-state', 'collapsed');
      $item.find('.pdp-fabrics-modal_faq_answer').slideUp(300);
    } else {
      $item.attr('data-state', 'expanded');
      $item.find('.pdp-fabrics-modal_faq_answer').slideDown(300);
    }
  });

  }); // end DOM ready
})(jQuery);
